export const IB_FETCH_AGENTS = 'IB_FETCH_AGENTS';
export const IB_FETCH_AGENTS_START = `${IB_FETCH_AGENTS}_START`;
export const IB_FETCH_AGENTS_SUCCESS = `${IB_FETCH_AGENTS}_SUCCESS`;
export const IB_FETCH_AGENTS_FAILURE = `${IB_FETCH_AGENTS}_FAIL`;

export const IB_FETCH_ENDPOINTS = 'IB_FETCH_ENDPOINTS';
export const IB_FETCH_ENDPOINTS_START = `${IB_FETCH_ENDPOINTS}_START`;
export const IB_FETCH_ENDPOINTS_SUCCESS = `${IB_FETCH_ENDPOINTS}_SUCCESS`;
export const IB_FETCH_ENDPOINTS_FAILURE = `${IB_FETCH_ENDPOINTS}_FAIL`;

export const IB_FETCH_FORMS = 'IB_FETCH_FORMS';
export const IB_FETCH_FORMS_START = `${IB_FETCH_FORMS}_START`;
export const IB_FETCH_FORMS_SUCCESS = `${IB_FETCH_FORMS}_SUCCESS`;
export const IB_FETCH_FORMS_FAILURE = `${IB_FETCH_FORMS}_FAIL`;

export const IB_FETCH_IASERVICES = 'IB_FETCH_IASERVICES';
export const IB_FETCH_IASERVICES_START = `${IB_FETCH_IASERVICES}_START`;
export const IB_FETCH_IASERVICES_SUCCESS = `${IB_FETCH_IASERVICES}_SUCCESS`;
export const IB_FETCH_IASERVICES_FAILURE = `${IB_FETCH_IASERVICES}_FAIL`;

export const IB_FETCH_INTEGRATIONS = 'IB_FETCH_INTEGRATIONS';
export const IB_FETCH_INTEGRATIONS_START = `${IB_FETCH_INTEGRATIONS}_START`;
export const IB_FETCH_INTEGRATIONS_SUCCESS = `${IB_FETCH_INTEGRATIONS}_SUCCESS`;
export const IB_FETCH_INTEGRATIONS_FAILURE = `${IB_FETCH_INTEGRATIONS}_FAIL`;

export const IB_FETCH_PLAN = 'IB_FETCH_PLAN';
export const IB_FETCH_PLAN_START = `${IB_FETCH_PLAN}_START`;
export const IB_FETCH_PLAN_SUCCESS = `${IB_FETCH_PLAN}_SUCCESS`;
export const IB_FETCH_PLAN_FAILURE = `${IB_FETCH_PLAN}_FAIL`;

export const IB_SAVE_INTEGRATION = 'IB_SAVE_INTEGRATION';
export const IB_SAVE_INTEGRATION_START = `${IB_SAVE_INTEGRATION}_START`;
export const IB_SAVE_INTEGRATION_SUCCESS = `${IB_SAVE_INTEGRATION}_SUCCESS`;
export const IB_SAVE_INTEGRATION_FAILURE = `${IB_SAVE_INTEGRATION}_FAIL`;

export const IB_INITIALIZE = 'IB_INITIALIZED';
export const IB_TRIGGER_CHANGED = 'IB_TRIGGER_CHANGED';
export const IB_FORM_CHANGED = 'IB_FORM_CHANGED';
export const IB_INTEGRATION_SELECTED = 'IB_INTEGRATION_SELECTED';

export const IB_ACTION_CHANGED = 'IB_ACTION_CHANGED';
export const IB_LOCATION_CHANGED = 'IB_LOCATION_CHANGED';

export const IB_PREPARE_CONNECT_GWT = 'IB_PREPARE_CONNECT_GWT';
export const IB_CONNECT_GWT_SUCCESS = 'IB_CONNECT_GWT_SUCCESS';
export const IB_GWT_INTEGRATION_SOLVED = 'IB_GWT_INTEGRATION_SOLVED';
export const IB_GWT_INTEGRATION_FAIL_SOLVE = 'IB_GWT_INTEGRATION_FAIL_SOLVE';

export const IB_SAVE_NAME = 'IB_SAVE_NAME';
export const IB_AGENT_CHANGED = 'IB_AGENT_CHANGED';
export const IB_ENDPOINT_CHANGED = 'IB_ENDPOINT_CHANGED';
export const IB_APPEND_URL_CHANGED = 'IB_APPEND_URL_CHANGED';
export const IB_INTEGRATION_SERVICE_CHANGED = 'IB_INTEGRATION_SERVICE_CHANGED';
export const IB_INTEGRATION_SERVICE_SELECTOR_CHANGED =
  'IB_INTEGRATION_SERVICE_SELECTOR_CHANGED';
export const IB_SCRIPT_CHANGED = 'IB_SCRIPT_CHANGED';
export const IB_ENDPOINT_LIST_CHANGED = 'IB_ENDPOINT_LIST_CHANGED';
export const IB_RESET = 'IB_RESET';

function filterIntegration(integration) {
  const {
    plan,
    form,
    name,
    operation,
    type,
    triggeredBy,
    deployed,
    environment,
    loggingLevel,
    id,
    script,
    integrationService,
    integrationServiceSelector,
    endpoint,
    appendToUrl,
    agents,
    createdBy,
    isOnPremiseWithNoAgent,
  } = integration;

  const result = {
    plan: {
      id: plan.id,
    },
    form: {
      id: form.id,
    },
    name,
    operation,
    type,
    triggeredBy,
    deployed,
    environment,
    loggingLevel,
    agents: [],
    createdBy,
  };

  if (id) {
    result.id = id;
  }
  if (operation === 'RUN_SCRIPT') {
    result.script = script;
  } else if (integration.operation === 'SEND_TO_IA') {
    result.environment = 'ONPREMISE';
    result.integrationService = integrationService;
    result.integrationServiceSelector = integrationServiceSelector;
  } else if (operation === 'SEND_WEBHOOK' && endpoint.id) {
    result.endpoint = { id: endpoint.id };
    result.appendToUrl = appendToUrl;
  }
  if (environment === 'ONPREMISE' && operation !== 'SEND_TO_IA') {
    result.agents = [...agents];
  }

  if (isOnPremiseWithNoAgent) {
    result.isOnPremiseWithNoAgent = false;
  }
  return result;
}

export function initialize(
  applicationId,
  planId,
  integrationId,
  integrationType,
) {
  return {
    type: IB_INITIALIZE,
    applicationId,
    planId,
    integrationId,
    integrationType,
  };
}

export function fetchIntegrations(planId) {
  return {
    type: IB_FETCH_INTEGRATIONS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/integrations?integrationType=OUTBOUND_WEBHOOK`,
      method: 'get',
    },
  };
}

export function fetchPlan(planId) {
  return {
    type: IB_FETCH_PLAN,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}`,
      method: 'get',
    },
  };
}

export function fetchForms(planId) {
  return {
    type: IB_FETCH_FORMS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/forms?embed=recipients`,
      method: 'get',
    },
  };
}

export function fetchAgents() {
  return {
    type: IB_FETCH_AGENTS,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agents?status="ALL"',
      method: 'get',
    },
  };
}

export function fetchEndpoints(planId) {
  return {
    type: IB_FETCH_ENDPOINTS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/endpoints`,
      method: 'get',
    },
  };
}

export function fetchIntegrationServices() {
  return {
    type: IB_FETCH_IASERVICES,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/integration-services',
      method: 'get',
    },
  };
}

export function saveIntegration(planId, integration) {
  const dup = filterIntegration(integration);
  dup.script = dup.script ? btoa(dup.script) : dup.script;
  return {
    type: IB_SAVE_INTEGRATION,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/integrations`,
      params: dup,
      method: 'post',
    },
  };
}

export function prepareConnectGwt() {
  return {
    type: IB_PREPARE_CONNECT_GWT,
  };
}

export function connectGwtSuccess() {
  return {
    type: IB_CONNECT_GWT_SUCCESS,
  };
}

export function selectTrigger(trigger) {
  return {
    type: IB_TRIGGER_CHANGED,
    trigger,
  };
}

export function selectForm(form) {
  return {
    type: IB_FORM_CHANGED,
    form,
  };
}

export function selectIntegration(integration) {
  return {
    type: IB_INTEGRATION_SELECTED,
    payload: integration,
  };
}

export function selectAction(action, hasAgent) {
  return {
    type: IB_ACTION_CHANGED,
    action,
    hasAgent,
  };
}

export function selectLocation(location) {
  return {
    type: IB_LOCATION_CHANGED,
    location,
  };
}

export function changeAgent(agent, selected) {
  return {
    type: IB_AGENT_CHANGED,
    selected,
    agent,
  };
}

export function changeEndpoint(endpoint) {
  return {
    type: IB_ENDPOINT_CHANGED,
    endpoint,
  };
}

export function changeAppendUrl(url) {
  return {
    type: IB_APPEND_URL_CHANGED,
    url,
  };
}

export function changeIntegrationService(service) {
  return {
    type: IB_INTEGRATION_SERVICE_CHANGED,
    service,
  };
}

export function changeIntegrationServiceSelector(selector) {
  return {
    type: IB_INTEGRATION_SERVICE_SELECTOR_CHANGED,
    selector,
  };
}

export function changeScript(script) {
  return {
    type: IB_SCRIPT_CHANGED,
    payload: script,
  };
}

export function changeEndpointList(name, id) {
  return {
    type: IB_ENDPOINT_LIST_CHANGED,
    payload: {
      name,
      id,
    },
  };
}

export function saveName(name) {
  return {
    type: IB_SAVE_NAME,
    name,
  };
}

export function reset() {
  return {
    type: IB_RESET,
  };
}
